import { Modal } from '@ts/components/Modal';
import { MetricWidget } from '@ts/components/MetricWidget';
import { storage } from '@ts/utils/';
import { ImageUploader } from '@ts/components/ImageUploader';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { CopyButton } from '@ts/components/CopyButton';

export const init = () => {
   checkMakeImpactModal();
   setMetricWidgets();
   setTeamLogoUploader();
   setDeleteTeamLogo();
   setUploadPhotoChecklist();
   setCopyButton();
   setOpenShopDecision();
}

const setCopyButton = () => {
    const copyBtns = document.querySelectorAll('.copy-shop-link-btn');
    copyBtns.forEach(copyBtn => {
        const shopUrl = copyBtn?.dataset.shareUrl ? new URL(copyBtn.dataset.shareUrl, window.location.origin).toString() : "";
        CopyButton.create(copyBtn, {
            text: shopUrl
        });
    });
}

const handleTeamLogoUpload = (response, container) => {
    const { viewUrl, file } = response;
    if (!viewUrl) return;

    /* Update Preview Image */
    const img = container.querySelector('.team-logo-preview img');
    img.src = viewUrl;
    container.dataset.viewMode = 'Complete';

    const uploadBtn = container.querySelector('#team-logo .btn-label');
    if (uploadBtn) {
        uploadBtn.textContent = uploadBtn.dataset.updateLogoLabel || 'Change Logo';
    }
}   

const toggleCreateShopLock = (isUnlocked) => {
    const shopLockMessage = document.querySelector('.lock-message');
    const organizerShopDecision = document.querySelector('.organizer-shop-decision');
    const organizerShopOpen = document.querySelector('.organizer-shop-open');
    if (!shopLockMessage || !organizerShopDecision || !organizerShopOpen) return;
    organizerShopOpen.setAttribute('hidden', 'true');
    if (isUnlocked) {
        shopLockMessage.setAttribute('hidden', 'true');
        organizerShopDecision.removeAttribute('hidden');
        organizerShopOpen.setAttribute('hidden', 'true');
    } else {
        shopLockMessage.removeAttribute('hidden');
        organizerShopDecision.setAttribute('hidden', 'true');
        
    }
}   

const setOpenShopDecision = () => {
    const declineShopBtn = document.querySelector('.organizer-shop-decision .no-shop');
    if (!declineShopBtn) return;

    declineShopBtn.addEventListener('click', (e) => {
        e.preventDefault();
        toggleCreateShopOpen(true);
    });
}

const toggleCreateShopOpen = (isOpen) => {
    const organizerShopDecision = document.querySelector('.organizer-shop-decision');
    const organizerShopOpen = document.querySelector('.organizer-shop-open');
    if (!organizerShopDecision || !organizerShopOpen) return;
    
    if (isOpen) {
        organizerShopDecision.setAttribute('hidden', 'true');
        organizerShopOpen.removeAttribute('hidden');
    } else {
        organizerShopDecision.removeAttribute('hidden');
        organizerShopOpen.setAttribute('hidden', 'true');
    }
}

const setTeamLogoUploader = () => {
    const uploaderInput = document.getElementById('team-logo');
    if (!uploaderInput) return;
    const container = uploaderInput.closest('.team-logo-upload-container');

    ImageUploader.create(uploaderInput, {
        uploadUrl: uploaderInput.dataset.uploadImageUrl || '',
        cropperMode: 'none',
        inputFileName: 'Logo',
        fileSizeLimit: 15 * 1024 * 1024, // 15 MB
        onSave: (response) => {
            handleTeamLogoUpload(response, container);
            toggleCreateShopLock(true);
        },
        onError: (error) => {
             Modal.createAlertModal({
                title: 'Image Upload Failed',
                message: error,
                closeBtnLabel: 'Close'
            });
            container.dataset.viewMode = 'Error';
        }
    }); 

    const logoUploaderTriggers = document.querySelectorAll('.upload-photo-checklist');
    logoUploaderTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            uploaderInput.click();
        });
    }); 
}

const handleDeleteLogo = (containerWrapper, deleteEndPoint) => {
    fetch(deleteEndPoint, {
        method: 'DELETE'
    }).then(response => {
        if (response.ok) {
            const img = containerWrapper.querySelector('.team-logo-preview img');
            if (img) {
                img.src = '';
                containerWrapper.dataset.viewMode = '';
            }
            toggleCreateShopLock(false);
                const uploadBtn = containerWrapper.querySelector('#team-logo');
                const uploadBtnLabel = uploadBtn?.querySelector('.btn-label');
                if (uploadBtnLabel) {
                    uploadBtnLabel.textContent = uploadBtn.dataset.uploadLogoLabel || 'Upload Logo';
                }
        } else {
            Modal.createAlertModal({
                title: 'Delete Failed',
                message: 'There was a problem deleting your logo, please try again.',
                closeBtnLabel: 'Close'
            });
        }
    }).catch(error => {
        console.error('Error deleting team logo:', error);
    });
}

const setDeleteTeamLogo = () => {
    const trigger = document.querySelector('.delete-team-logo');
    if (!trigger) return;
    const container = trigger.closest('.team-logo-upload-container');
    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const deleteEndPoint = trigger.dataset.deleteLogoUrl;
        if (!deleteEndPoint) return;
        
        Modal.createConfirmModal({
            title: 'Delete Team Logo',
            message: 'Are you sure you want to delete this logo? This action cannot be undone.',
            confirmText: 'Delete',
            cancelText: 'Cancel',
            onConfirm: async () => {
                const containerWrapper = trigger.closest('.team-logo-upload-container');
                handleDeleteLogo(containerWrapper, deleteEndPoint);
            }
        });
    });
}

const setMetricWidgets = () => {
    MetricWidget.create();
}

const checkMakeImpactModal = () => {
    const makeAnImpactModal = document.getElementById('make-an-impact-modal');
    if (!makeAnImpactModal) return;
    const guid = window.location.pathname.split('/').pop();
    const storageId = 'makeImpactModalShown-' + guid;

    if (!storage.get(storageId)) {
        storage.set(storageId, 'true');
        const modalTitle = makeAnImpactModal?.dataset.modalTitle;
        Modal.create('#make-an-impact-modal', {
            modalTitle: modalTitle ?? 'Keys to Success',
            modalSize: 'modal-sm'
        });
    }
}

const setUploadPhotoChecklist = () => {
    const trigger = document.querySelector('.upload-photo-checklist');
    const uploadPhotoBtn = document.getElementById('team-logo');
    if (!trigger || !uploadPhotoBtn) return;

    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        uploadPhotoBtn.click();
    });
}